var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42457 4.14214L1.50567 0.178217C1.29921 0.0599473 1.09368 0 0.894393 0C0.367868 0 0 0.42252 0 1.02759V8.97241C0 9.57748 0.367868 10 0.894393 10C1.09368 10 1.29921 9.93987 1.50567 9.82178L8.42457 5.85786C8.79024 5.64823 9 5.33567 9 5C9 4.66433 8.79024 4.35177 8.42457 4.14214Z",
    fill: "#61BB46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.b336db0dd013ea5a947c83fdf4223649.svg";
export { ForwardRef as ReactComponent };